<header *ngIf="LinkDisable ==0">
  <nav class="navbar navbar-expand-lg navbar-light">
    <a class="navbar-brand" [routerLink]="['/assigned']"><img src="assets/images/logo.svg" /></a>

    <div class="collapse navbar-collapse" id="navbarNavDropdown"
      [ngClass]="navigationShow ? 'navbar-collapse show' : 'collapse'">
      <ul class="navbar-nav">
        <li class="nav-item mobileShow">
          <div class="user">
            <span>{{userLoginData?.first_name+" " + userLoginData?.last_name}}</span> <button
              [routerLink]="['/change_password']"><img src="assets/images/icons/lock.png" /></button>
          </div>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" href="javascript:void(0);" [routerLink]="['/assigned']">Assigned Courses <span
              class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" href="javascript:void(0);" [routerLink]="['/completed']">Completed Courses</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" href="javascript:void(0);" [routerLink]="['/assessments']">Assessments</a>
        </li>
        <!-- <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" href="javascript:void(0);" [routerLink]="['/course-library']">Course Library</a>
        </li> -->
      </ul>
    </div>
    <div class="form-inline my-2 my-lg-0 mobileNav">
      <div class="user">
        <div class="uploadImageWrap">
          <figure style="background: url({{userLoginData?.user_image}});">
              <!-- <img src="{{userLoginData?.user_image}}" /> -->
          </figure>
          </div>
          <div class="userPosition">
              <span>{{userLoginData?.first_name+" " + userLoginData?.last_name}}</span>
              <i class="active">Active</i>
          </div>
        <button mat-button [matMenuTriggerFor]="menu" class="openDrop">
          <i><svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
            <path d="M1 1L6 6L11 1" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg></i>
        </button>
        <mat-menu #menu="matMenu">
          <div class="matMenuList">
            <button mat-menu-item [routerLink]="['/change_password']" class="cngPassword"><i><svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
              <path d="M11.9653 2.20175L6.28684 0.0307602C6.1836 -0.0102534 6.0664 -0.0102534 5.96316 0.0307602L0.284672 2.20175C0.111666 2.26737 -0.00274048 2.43142 4.99281e-05 2.61462C0.0307444 5.46096 0.200959 7.44329 0.993436 9.14672C1.81661 10.9185 3.28157 12.3513 5.89061 13.9344C5.96316 13.9781 6.04408 14 6.125 14C6.20592 14 6.28684 13.9781 6.35939 13.9344C8.96843 12.3513 10.4334 10.9185 11.2566 9.14672C12.049 7.44329 12.2193 5.46096 12.25 2.61462C12.2527 2.43142 12.1383 2.26737 11.9653 2.20175ZM5.96316 1.93926L2.11797 3.41028C1.94218 3.47864 1.82777 3.64543 1.83335 3.82862C1.87242 5.25043 2.00356 7.06323 2.66489 8.45496C3.23134 9.64709 4.24984 10.7134 5.87107 11.8044C5.94641 11.8564 6.03571 11.881 6.125 11.881C6.21429 11.881 6.3008 11.8564 6.37893 11.8044C8.00016 10.7134 9.02145 9.64982 9.5879 8.45496C10.2464 7.06323 10.3776 5.25043 10.4194 3.82862C10.425 3.64269 10.3106 3.4759 10.1348 3.41028L6.28684 1.93926C6.1836 1.89825 6.0664 1.89825 5.96316 1.93926ZM6.125 13.0457C1.50966 10.1857 0.968322 7.91905 0.895772 2.90718L6.125 0.908452L11.3542 2.90718C11.2817 7.91905 10.7403 10.1857 6.125 13.0457Z" fill="#F06715"/>
              </svg></i>Change password</button>
          </div>
          <div class="matMenuList">
            <button mat-menu-item class="my-2 my-sm-0 logout" (click)="open(suucessPassword)"><i><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.529397 5.40179C0.197192 5.40179 -0.0361633 5.13444 0.0167923 4.80827C0.0167923 4.80827 -0.0219536 4.99972 0.0177231 4.80363C0.572243 2.06313 2.99441 0 5.89844 0C9.21215 0 11.8984 2.68629 11.8984 6C11.8984 9.31371 9.21215 12 5.89844 12C2.99763 12 0.577631 9.94145 0.0195799 7.20551C-0.0210037 7.00654 0.0167093 7.19118 0.0167093 7.19118C-0.0323372 6.86379 0.197458 6.59839 0.529412 6.59839L6.20119 6.59839C6.42234 6.59839 6.47403 6.72512 6.31671 6.88139L5.2257 7.96781C4.66009 8.53201 5.50871 9.378 6.07432 8.81401L8.5215 6.40882C8.75809 6.17708 8.75769 5.80264 8.51867 5.57061L6.07432 3.18597C5.50871 2.62197 4.66009 3.46817 5.2257 4.03216L6.31671 5.11873C6.47406 5.27506 6.42142 5.40179 6.20119 5.40179L0.529397 5.40179Z" fill="#888888"/>
            </svg></i>logout</button>
          </div>


        </mat-menu>

      </div>

      <button class="navbar-toggler" (click)="navigationToggle()" (click)="open(suucessPassword)" type="button" data-toggle="collapse"
        data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
  </nav>
</header>
<ng-template #suucessPassword let-modal>
  <div class="modal-body">
      <div class="holdPopup text-center">
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">&times;</span>
          </button>
          <div>
              <p class="size18">Are you sure you want to logout?</p>
              <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
              <span class="backPage ml-2 mr-2" (click)="modal.dismiss('Cross click')">Cancel</span>&nbsp;
              <span class="btn btn-primary" (click)="navigationEvent();modal.dismiss('Cross click')">Confirm</span>

          </div>
      </div>
  </div>
</ng-template>
